import { PRODUCT_OPTION_TYPES_SERVER } from "@graphql/fragments/product/server/option-types";
import { BASIC_VARIANT_DETAILS_SERVER } from "@graphql/fragments/product/server/basic-variant-details";
import { TAXON_BASICS_DETAILS_SERVER } from "@graphql/fragments/taxon/basic-details/server";
import { BASIC_VARIANT_PRICE_DETAILS_SERVER } from "@graphql/fragments/product/server/basic-variants-price-details";

export const PRODUCT_ADDITIONAL_DETAILS_SERVER = `
  fragment ProductAdditionalDetails on Product {
    componentProductIds
    description
    rawDescription
    sizeChartEnabled
    sizeChartLink
    sizeChart
    askForPreference
    askForPreferenceMessage
    askForRestriction
    intent
    variantImages(storeNumber: $storeNumber, country: $country)
    ingredients
    hasTierPricing
    priceIn(currency: $currency)
    currentCatalogExternalStoreId
    optionTypes {
      ...OptionTypes
    }
    productDetail {
      orderInstructions
    }
    variantsIncludingMaster(
      number: $storeNumber
      viewingInsideByoMedley: $viewingInsideByoMedley
      country: $country
    ) {
      ... on Variant {
        ...BasicVariantDetails
      }
      ... on Price {
        ...BasicVariantPriceDetails
      }
    }
    dietaryRestrictions {
      id
      name
      icon
    }
    relatedTaxon {
      ...TaxonBasicDetails
      parent {
        ...TaxonBasicDetails
      }
    }
    taxons {
      id
      depth
      name
    }
    bulkAvailable
    masterVariant {
      ... on Variant {
        ...BasicVariantDetails
        sku
      }
    }
    prices(currency: $currency, number: $storeNumber)
    catalogStoreId
    type
  }
  ${PRODUCT_OPTION_TYPES_SERVER}
  ${BASIC_VARIANT_DETAILS_SERVER}
  ${BASIC_VARIANT_PRICE_DETAILS_SERVER}
  ${TAXON_BASICS_DETAILS_SERVER}
`;
